import React from 'react';
import * as S from './AnimatedLogo.style';

export const AnimatedLogo = () => {
  return (
    <S.LogoContainer>
      <S.LogoText>semn</S.LogoText>
      <S.MiddleDot>.</S.MiddleDot>
      <S.LogoText>
        a<S.ILetter>ı</S.ILetter>
      </S.LogoText>
    </S.LogoContainer>
  );
};
